import React, { ComponentType } from 'react';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';

/**
 * Higher-Order Component to automatically set page titles
 * Usage: export default withPageTitle('Dashboard')(YourComponent);
 */
export const withPageTitle = <P extends object>(title: string) => {
  return (WrappedComponent: ComponentType<P>) => {
    const WithPageTitleComponent = (props: P) => {
      // Set the document title using our custom hook
      useDocumentTitle(title);

      return <WrappedComponent {...props} />;
    };

    // Set display name for debugging
    WithPageTitleComponent.displayName = `withPageTitle(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;

    return WithPageTitleComponent;
  };
};

/**
 * Hook version - use in functional components
 * Usage: usePage('Dashboard');
 */
export const usePage = (title: string) => {
  useDocumentTitle(title);
};

export default withPageTitle;
